import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        :host {\n          display: inline-block;\n          position: relative;\n        }\n        path {\n          stroke: currentColor;\n          stroke-opacity: 0.65;\n          stroke-width: 1.5;\n          fill: none;\n        }\n        .knob {\n          stroke-width: 2.8 !important;\n          stroke-opacity: 1;\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["<svg></svg>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { WiredBase, BaseCSS } from 'wired-lib/lib/wired-base';
import { customElement, property, css, html } from 'lit-element';
import { ellipse, hachureEllipseFill } from 'wired-lib';

var WiredSpinner = /*#__PURE__*/function (_WiredBase) {
  _inherits(WiredSpinner, _WiredBase);

  var _super = _createSuper(WiredSpinner);

  function WiredSpinner() {
    var _this;

    _classCallCheck(this, WiredSpinner);

    _this = _super.apply(this, arguments);
    _this.spinning = false;
    _this.duration = 1500;
    _this.value = 0;
    _this.timerstart = 0;
    _this.frame = 0;
    return _this;
  }

  _createClass(WiredSpinner, [{
    key: "render",
    value: function render() {
      return html(_templateObject());
    }
  }, {
    key: "canvasSize",
    value: function canvasSize() {
      return [76, 76];
    }
  }, {
    key: "draw",
    value: function draw(svg, size) {
      ellipse(svg, size[0] / 2, size[1] / 2, Math.floor(size[0] * 0.8), Math.floor(0.8 * size[1]), this.seed);
      this.knob = hachureEllipseFill(0, 0, 20, 20, this.seed);
      this.knob.classList.add('knob');
      svg.appendChild(this.knob);
      this.updateCursor();
    }
  }, {
    key: "updateCursor",
    value: function updateCursor() {
      if (this.knob) {
        var position = [Math.round(38 + 25 * Math.cos(this.value * Math.PI * 2)), Math.round(38 + 25 * Math.sin(this.value * Math.PI * 2))];
        this.knob.style.transform = "translate3d(".concat(position[0], "px, ").concat(position[1], "px, 0) rotateZ(").concat(Math.round(this.value * 360 * 2), "deg)");
      }
    }
  }, {
    key: "updated",
    value: function updated() {
      _get(_getPrototypeOf(WiredSpinner.prototype), "updated", this).call(this);

      if (this.spinning) {
        this.startSpinner();
      } else {
        this.stopSpinner();
      }
    }
  }, {
    key: "startSpinner",
    value: function startSpinner() {
      this.stopSpinner();
      this.value = 0;
      this.timerstart = 0;
      this.nextTick();
    }
  }, {
    key: "stopSpinner",
    value: function stopSpinner() {
      if (this.frame) {
        window.cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    }
  }, {
    key: "nextTick",
    value: function nextTick() {
      var _this2 = this;

      this.frame = window.requestAnimationFrame(function (t) {
        return _this2.tick(t);
      });
    }
  }, {
    key: "tick",
    value: function tick(t) {
      if (this.spinning) {
        if (!this.timerstart) {
          this.timerstart = t;
        }

        this.value = Math.min(1, (t - this.timerstart) / this.duration);
        this.updateCursor();

        if (this.value >= 1) {
          this.value = 0;
          this.timerstart = 0;
        }

        this.nextTick();
      } else {
        this.frame = 0;
      }
    }
  }], [{
    key: "styles",
    get: function get() {
      return [BaseCSS, css(_templateObject2())];
    }
  }]);

  return WiredSpinner;
}(WiredBase);

__decorate([property({
  type: Boolean
}), __metadata("design:type", Object)], WiredSpinner.prototype, "spinning", void 0);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredSpinner.prototype, "duration", void 0);

WiredSpinner = __decorate([customElement('wired-spinner')], WiredSpinner);
export { WiredSpinner };